import React from "react";
import ReactDOM from "react-dom/client";
import Sentry from "@/sentry";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { localeReady } from "@/i18n";
import { registerServiceWorker } from "@/lib/pwa";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"), {
  // React 19 error hooks -> Sentry. onCaughtError is intentionally left to our own
  // ErrorBoundary (which already reports) to avoid duplicate events.
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
registerServiceWorker();

// Wait (briefly) for a non-English pack so returning users don't see an English flash.
localeReady.finally(() => root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
));
